var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74334740-AA69-4652-B7E8-AB35AFB0B19A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share-Modal",
    transform: "translate(-814.000000, -451.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(682.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(132.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#55ACEE",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,28.4986162 C62.3080266,29.2612633 60.4879586,29.7770875 58.5792099,30.0074555 C60.5280761,28.8205592 62.0236849,26.9425586 62.7296123,24.7011202 C60.9060253,25.8007343 58.8853698,26.5984374 56.7366198,27.0284101 C55.0150861,25.1647181 52.5622877,24 49.8462621,24 C44.6352092,24 40.4087946,28.2961499 40.4087946,33.5931846 C40.4087946,34.3451003 40.4925487,35.0769839 40.6544264,35.779535 C32.8111019,35.3796103 25.856697,31.5606514 21.2016586,25.7549468 C20.389455,27.1714958 19.9235289,28.8205592 19.9235289,30.5783677 C19.9235289,33.905827 21.5908688,36.8433776 24.1217908,38.5632684 C22.5755072,38.5139038 21.1193121,38.0825002 19.8475168,37.3620634 C19.8468129,37.4028429 19.8468129,37.4436223 19.8468129,37.4836863 C19.8468129,42.1318272 23.1012577,46.0087358 27.4177606,46.8894286 C26.6266716,47.1097807 25.7912421,47.2263956 24.9318829,47.2263956 C24.3223783,47.2263956 23.7318767,47.167015 23.1561553,47.0554081 C24.3568653,50.8657818 27.8414578,53.6394992 31.9721534,53.7174809 C28.7416384,56.2908783 24.6728786,57.8240422 20.2500995,57.8240422 C19.4899783,57.8240422 18.7368953,57.7789702 18,57.6895416 C22.1743321,60.4124635 27.1362343,62 32.4655283,62 C49.8244438,62 59.3175128,47.382359 59.3175128,34.7042455 C59.3175128,34.2885814 59.3083632,33.8743481 59.290064,33.463692 C61.1354693,32.1115316 62.7352428,30.4224042 64,28.4986162 L64,28.4986162 Z",
    id: "Path",
    fill: "#F1F2F2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c1fcb25e4d6f32826adc49d2d6d3551a.svg";
export { ForwardRef as ReactComponent };